import { useState, useEffect } from "react";
import { Request } from "../api/eklok/Eklok.api";
import { setConnected } from "../utils/date";
import _cloneDeep from "lodash/cloneDeep";

const useUpdateEkloks = ({ access }, ekloks) => {
  const [reload, setReload] = useState(false);
  const [response, setResponse] = useState([]);
  const [isPending, setIsPending] = useState(false);

  const onSuccess = () =>
    setTimeout(
      () =>
        Request.ekloks(access).then((result) => {
          const status = result.data.data.map((eklok) => ({
            id: eklok.id,
            name: eklok.name,
            connected: eklok.last_mqtt_update
              ? setConnected(eklok.last_mqtt_update)
              : false,
            last_mqtt_update: eklok.last_mqtt_update
              ? eklok.last_mqtt_update
              : false,
            alarm_list: eklok.alarm_list
              ? JSON.parse(
                  eklok.alarm_list
                    .replace(/'/g, '"')
                    .replace(/"[{"/g, '[{"').replace(/}]",/g, "}],")
                    .replace(/}]}"/g, "}]"),
                )
              : null,
          }));
          setResponse(status);
          setIsPending(false)
        }),
      5000,
    );

  const onFailure = (error) => {
      console.log(error)
      setIsPending(false)
  };

  useEffect(() => {
    if (ekloks.length > 0 && reload === false) {
      setReload(true);
      setIsPending(true)
      Request.updateStatus(
        access,
        ekloks.filter((item) => item !== null).map((item) => item.id),
      )
        .then(onSuccess)
        .catch(onFailure);
      setTimeout(() => setReload(false), 5 * 60 * 1000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ekloks]);

  const onSuccessReload = (items) =>
    setTimeout(
      () =>
        Request.ekloks(access).then((result) => {
          let status = _cloneDeep(response);
          items.forEach((element) => {
            const eklok = result.data.data.find((item) => item.id === element);
            status = status.map((obj) =>
              obj.id === eklok.id
                ? {
                    ...eklok,
                    alarm_list: eklok.alarm_list
                      ? JSON.parse(
                          eklok.alarm_list
                            .replace(/'/g, '"')
                            .replace(/"[{"/g, '[{"').replace(/}]",/g, "}],")
                            .replace(/}]}"/g, "}]"),
                        )
                      : null,
                    connected: eklok.last_mqtt_update
                      ? setConnected(eklok.last_mqtt_update)
                      : false,
                  }
                : obj,
            );
          });
          setResponse(status);
          setIsPending(false)
        }),
      5000,
    );

  const reloadEkloks = (items) => {
      setIsPending(true)
    const status = _cloneDeep(response);
    items.forEach((element) => {
      const eklok = status.find((item) => item.id === element);
      if (eklok) {
        eklok.connected = undefined;
      }
    });
    setResponse(status);
    Request.updateStatus(access, items)
      .then(() => onSuccessReload(items))
      .catch(onFailure);
  };

  return [response, reloadEkloks, isPending];
};

export default useUpdateEkloks;
